import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Stack,
} from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import ADMIN_NAV_ITEMS from './nav';
import AdminNavLink from './AdminNavLink';
import SiesaLogo from '../../../components/ui/SiesaLogo';

/**
 * Drawer de navegación para pantallas por debajo de `lg`, controlado
 * desde fuera (`isOpen`/`onClose`, ver `AdminLayout`) por el botón de
 * hamburguesa de `AdminTopbar`. El Drawer de Chakra ya resuelve foco
 * atrapado, cierre con Escape y bloqueo de scroll: nada de eso se
 * reimplementa aquí. `bg="adminPanel.navy"` en `DrawerContent` es
 * deliberado -no usa la variante `publicSurface` (blanca) del tema,
 * porque este Drawer debe verse igual que el sidebar de escritorio.
 */
export default function AdminMobileDrawer({ isOpen, onClose }) {
  const { pathname } = useLocation();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="left" size="xs">
      <DrawerOverlay />
      <DrawerContent bg="adminPanel.navy" color="white">
        <DrawerCloseButton
          aria-label="Cerrar menú de navegación"
          color="white"
          minW="44px"
          minH="44px"
        />
        <Flex align="center" h="76px" px="18px" py="16px" flexShrink={0}>
          <SiesaLogo variant="lightOnDark" w="138px" maxH="34px" />
        </Flex>
        <DrawerBody px={0} py="4px" bg="adminPanel.navy">
          <Stack as="nav" aria-label="Navegación administrativa" spacing="10px">
            {ADMIN_NAV_ITEMS.map(item => (
              <AdminNavLink
                key={item.href}
                item={item}
                isActive={pathname === item.href}
                onClick={onClose}
              />
            ))}
          </Stack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
